import { render, staticRenderFns } from "./BudgetGlobal.vue?vue&type=template&id=53c8dec8&scoped=true&"
import script from "./BudgetGlobal.vue?vue&type=script&lang=js&"
export * from "./BudgetGlobal.vue?vue&type=script&lang=js&"
import style0 from "./BudgetGlobal.vue?vue&type=style&index=0&id=53c8dec8&scoped=true&lang=css&"
import style1 from "./BudgetGlobal.vue?vue&type=style&index=1&id=53c8dec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c8dec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c8dec8')) {
      api.createRecord('53c8dec8', component.options)
    } else {
      api.reload('53c8dec8', component.options)
    }
    module.hot.accept("./BudgetGlobal.vue?vue&type=template&id=53c8dec8&scoped=true&", function () {
      api.rerender('53c8dec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget/BudgetGlobal.vue"
export default component.exports